import { errorText } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import { SeverityDisplayContainer } from '../../../containers/summary-item/SeverityDisplayContainer';
import { SeverityType, SurveyStep } from '../../../models';

export interface IWarningBoxProps {
	severity: SeverityType;
	messages: string[];
	linkToStep?: SurveyStep;
}

export const WarningsBoxContainer = styled.div`
	${errorText}
	padding-top: 10px;
`;
WarningsBoxContainer.displayName = 'WarningsBoxContainer';

export class WarningBox extends React.Component<IWarningBoxProps> {
	public render() {
		const { severity, messages, linkToStep } = this.props;

		return (
			<WarningsBoxContainer>
				{messages.map((e, i) => (
					<SeverityDisplayContainer key={i} severity={severity} message={e} relatedStep={linkToStep} showSeverityPrefix={true} />
				))}
			</WarningsBoxContainer>
		);
	}
}
